import {
  ActivateCampaignAdCreativeTemplates,
  AdcreativeTemplate,
} from '@promoboxx/graphql-gateway-types'

export function generateCreative({
  adCreativeTemplate,
  formValues,
}: {
  adCreativeTemplate: AdcreativeTemplate
  formValues: any
}): ActivateCampaignAdCreativeTemplates {
  const creative: ActivateCampaignAdCreativeTemplates = {
    adcreative_template_id: adCreativeTemplate.id,
  }

  if (adCreativeTemplate.creative_type === 'carousel') {
    adCreativeTemplate.creative?.child_attachments?.forEach(
      (childAttachment, i) => {
        let urlOverride
        let ctaOverride

        if (
          childAttachment.link?.url !==
          formValues.adCreativeTemplate.creative.child_attachments[i].link.url
        ) {
          urlOverride =
            formValues.adCreativeTemplate.creative.child_attachments?.[i].link
              .url
        }

        if (
          childAttachment.call_to_action?.cta_type !==
          formValues.adCreativeTemplate.creative.child_attachments[i]
            .call_to_action.cta_type
        ) {
          ctaOverride =
            formValues.adCreativeTemplate.creative.child_attachments[i]
              .call_to_action.cta_type
        }

        if (!urlOverride && !ctaOverride) {
          creative.child_attachments = creative.child_attachments || []
          creative.child_attachments.push({
            id: childAttachment.id,
            child_attachment_id: childAttachment.id,
            url_override: urlOverride,
            call_to_action_override: ctaOverride,
          })
        }
      },
    )
  } else {
    if (
      adCreativeTemplate.creative?.link?.url !==
      formValues.adCreativeTemplate.creative.link.url
    ) {
      creative.url_override = formValues.adCreativeTemplate.creative.link.url
    }

    if (
      adCreativeTemplate.creative?.call_to_action?.cta_type !==
      formValues.adCreativeTemplate.creative.call_to_action.cta_type
    ) {
      creative.call_to_action_override =
        formValues.adCreativeTemplate.creative.call_to_action.cta_type
    }
  }
  return creative
}
